<template>
  <div class="content" :style="curHeight && `height: ${curHeight}px`">
    <div class="background-index">
      <div
        class="top-title common"
      >
        马上就办 最多跑一趟
      </div>
      <div
        class="middle-title common"
      >
      Right Away and All at Once
      </div>
      <div class="bottom-operator common">
        <BreadCrumbs />
      </div>
      <div class="common content-operator sss">
        <div class="common" >
          <!-- @mouseleave="" -->
          <div class="content-middle">
            <img src="../../../assets/images/bg2.png" alt="遮罩图片">
            <div class="mask-title left-right-border">
              <p>办事指南</p>
              <p>Business Guide</p>
            </div>
            <p class="left-right-border" style="height: 24px">  </p>
            <div class="scroll">
              <div
                v-for="item,index in list"
                :key="index"
                :class="getFocus(item.contentCode) === 'focus' ? 'focus-list list-content' : 'list-content'"
                @click="goDetail(item)"
                @mouseenter.stop="() => {
                  setTarget(item.contentCode)
                  getDetail(item.contentCode, item.tenantCode)
                }">
                <template>
                 <div class="nav-box">
                    <p> <i></i>{{ item.contentTitle }}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="content-right" v-if="currentEname">
            <div class="content-right-top" ref="right">
              
              <Content :data="detail" :open="open"/>
              <div class="more" @click="open = true" v-show="!open">显示全文 <a-icon type="down"></a-icon></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const list = [
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: 'Japan visa', icon: require('../../../assets/images/icon_window_service_japan_visa_.png'), iconf: require('../../../assets/images/icon_window_service_japan_visa.png') },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: 'Consular certification', icon: require('../../../assets/images/icon_window_service_consular_certification.png'), iconf: require('../../../assets/images/icon_window_service_consular_certification_.png') },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: 'Translation Services', icon: require('../../../assets/images/icon_window_service_translation_documents.png'), iconf: require('../../../assets/images/icon_window_service_translation_documents_.png') },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: 'Overseas Services', icon: require('../../../assets/images/icon_window_service_air_services.png'), iconf: require('../../../assets/images/icon_window_service_air_services_.png') },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: 'Services for Foreign Enterprises', icon: require('../../../assets/images/icon_window_service_foreign.png'), iconf: require('../../../assets/images/icon_window_service_foreign_.png') },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: '' },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: '' },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: '' },
  { name: '省外事服务中心全面落实“马上 就办网上办”', ename: '' },
]
import BreadCrumbs from '@/components/home/breadCrumbs'
import Content from './siderContent-01.vue'
import {
  getOfficeService,
  getOfficeDetailts
} from '@/api/service'
export default {
  name: 'office-service',
  components: {
    BreadCrumbs,
    Content
  },
  data () {
    return {
      list,
      currentEname: '',
      detail: {},
      open: false,
      curHeight: '1230',
  
    }
  },
  computed: {
    getFocus () {
      return function (val) {
        return this.currentEname === val ? 'focus' : ''
      }
    }
  },
  watch: {
    open: function (val) {
      this.$nextTick(() => {
        if (!val) {
          this.curHeight = '1230'
          return
        }
        this.curHeight = this._.get(this, '$refs.right.scrollHeight', '1000') + 460
        this.curHeight = 1230
        // console.log(this.curHeight, 123, this._.get(this, '$refs.right.scrollHeight', '1000'))
      })
    }
  },
  async created () {
    window.scrollTo(0,0)
    await this.getlist()
    this.currentEname = this._.get(this.list, '0.contentCode', '')
    const tenantCode = this._.get(this.list, '0.tenantCode', '')
    this.getDetail(this.currentEname, tenantCode)
  },
  methods: {
    goDetail (item) {
      this.pushRouter(`/htmlContent?type=contentAnnounce&contentCode=${item.contentCode}&name=${item.contentTitle}&linkname=办事指南/详情`)
    },
    getDetail (contentCode, tenantCode) {
      getOfficeDetailts(contentCode, tenantCode).then(res => {
        this.detail = this._.get(res, 'data', {})
      })
    },
    getlist () {
      return new Promise((resolve, reject) => {
        getOfficeService().then(res => {
          this.list = this._.get(res, 'data.records', [])
          resolve()
        }).catch(e => reject())
      })
    },
    changeSwiper (name) {
      this.$refs.swiper && this.$refs.swiper[name]()
    },
    setTarget (ename) {
      // if (!ename) return
      this.open = false
      this.currentEname = ename
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  //height: 1000px; 
  margin-bottom: -50px;
}
.background-index {
  height: 190px;
  width: 100%;
  position: absolute;
  index: -1;
  background-image: url('../../../assets/images/icon_window_service_bg.png');
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-position:center;
}
.top-title {
  width: 100%;
  height: 65px;
  font-size: 55px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 30px;
  top: 60px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  top: 130px;
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.bottom-operator {
  width: 100%;
  height: 120px;
  top: 190px;
  left: 0;
  transform: translateX(0);
  background: white;
}
.content-operator {
  top: 293px;
  background: white;
  height: 800px;
  width: 100%;
  min-width: 1366px;
  > div {
    width: 1140px;
    display: flex;
  }
}
.content-middle {
  width: 320px;
  height: 620px;
  position: relative;
  img {
    width: 318px;
    //margin-bottom: 24px;
  }
  .mask-title {
    position: absolute;
    top: 21px;
    left: 0;
    width: 100%;
    height: 89px;
    p {
      margin: 0;
      padding: 0;
      text-align: center;
      width: 100%;
    }
    p:nth-of-type(1) {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }
    p:nth-of-type(2) {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}
.list-content:not(:last-of-type) {
  border-left: 1px solid #E5E5E5;
  border-right: 1px solid #E5E5E5;
  border-top: 1px solid #E5E5E5;
}
.list-content:last-of-type {
  border: 1px solid #E5E5E5;
}
.list-content {
  cursor: pointer;
  display: flex;
  padding: 12px 0;
  height: 80px;
  img {
    width: 32px;
    height: 32px;
    transform: translateY(10px);
    margin: 0 29px 0 24px;
  }
  .nav-box {
    position: relative;
    padding: 0 40px;
    i {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #7F7F7F;
      vertical-align: middle;
      margin: 0 6px 0 0px;
    }
    p {
      margin: 0;
      padding: 0;
      text-align: left;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    p:nth-of-type(1) {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      padding-top: 7px;
    }
    p:nth-of-type(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7F7F7F;
      line-height: 14px;
      padding-top: 10px;
    }
  }
}
.focus-list {
  background: #CBB486;
  .nav-box {
    p:nth-of-type(2) {
      color: white;
    }
    p:nth-of-type(1) {
      color: white;
    }
    i {
      background: white;
      vertical-align: middle;
    }
  }
}
.content-right {
  width: 820px;
  min-height: 753px;
  margin-top: 20px;
  position: relative;
  border: 1px solid #ebebeb;
  -webkit-box-shadow: 2px 2px 8px 2px #f8f8f8;
  -moz-box-shadow: 2px 2px 8px 2px #f8f8f8;
  box-shadow: 2px 2px 2px 2px #f8f8f8;
  .content-right-top {
    position: relative;
    // height: 680px; 
    // overflow: hidden;
  }
}
.swiper {
  height: 587px;
}
.arrow {
  width: 42px;
  height: 70px;
  background: #000000;
  opacity: 0.64;
  position: absolute;
  font-size: 30px;
  line-height: 70px;
  cursor: pointer;
}
.right-ar {
  top: 45%;
  right: 0;
}
.left-ar {
  top: 45%;
  left: 0;
}
.scroll {
  overflow-y: scroll;
  height: 640px;
  border-left: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  -webkit-box-shadow: -2px 2px 8px 2px #f8f8f8;
  -moz-box-shadow: -2px 2px 8px 2px #f8f8f8;
  box-shadow: -2px 2px 8px 2px #f8f8f8;
}
.more {
  color: #CDAD7F;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  left: 45%;

}
.left-right-border {
  border-left: 1px solid #ebebeb;
  border-right: 1px solid #ebebeb;
}
p.left-right-border {
  margin-bottom: 0;
}
/deep/ .html-content {
  height: 340px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/content/officeService/index.vue